"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getIsFileOptimizableImage;

var _immutable = require("immutable");

var _Constants = require("FileManagerCore/Constants");

var _fileAccessibility = require("FileManagerCore/utils/fileAccessibility");

function getIsFileOptimizableImage(file) {
  if (_immutable.Map.isMap(file)) {
    return parseInt(file.get('width'), 10) > 0 && file.get('type') === _Constants.FileTypes.IMG && file.get('encoding') !== 'svg' && (0, _fileAccessibility.getIsFileAccessibleAnonymously)(file);
  }

  return false;
}

module.exports = exports.default;